
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree79d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree79d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i2AbA", function(module, exports) {

$parcel$export(module.exports, "cleanForm", () => $d2247bac48b6a171$export$dc46a306c32dfa78);
const $d2247bac48b6a171$var$form = document.getElementById("form");
const $d2247bac48b6a171$var$usernameLabel = document.getElementById("username-label");
const $d2247bac48b6a171$var$emailLabel = document.getElementById("email-label");
const $d2247bac48b6a171$var$usernameErrTxt = document.getElementById("username-field-error");
const $d2247bac48b6a171$var$emailErrTxt = document.getElementById("email-field-error");
const $d2247bac48b6a171$export$5a2bf26922253ae6 = document.getElementById("username-field");
const $d2247bac48b6a171$export$b60f3aad14353aa5 = document.getElementById("email-field");
const $d2247bac48b6a171$var$emptyFieldError = "This field is required";
const $d2247bac48b6a171$var$invalidEmailError = "This email is invalid";
const $d2247bac48b6a171$var$validateEmail = (email)=>{
    return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
};
const $d2247bac48b6a171$var$setError = (label, field, txt, error)=>{
    label.classList.add("error");
    txt.innerText = error;
    field.onchange = ()=>{
        txt.innerText = "";
        label.classList.remove("error");
        field.onchange = null;
    };
};
const $d2247bac48b6a171$export$dc46a306c32dfa78 = ()=>{
    $d2247bac48b6a171$var$emailLabel.classList.remove("error");
    $d2247bac48b6a171$var$usernameLabel.classList.remove("error");
    $d2247bac48b6a171$export$5a2bf26922253ae6.value = "";
    $d2247bac48b6a171$export$b60f3aad14353aa5.value = "";
    $d2247bac48b6a171$export$5a2bf26922253ae6.onchange = null;
    $d2247bac48b6a171$export$b60f3aad14353aa5.onchange = null;
};
const $d2247bac48b6a171$var$setEmailError = (err)=>{
    $d2247bac48b6a171$var$setError($d2247bac48b6a171$var$emailLabel, $d2247bac48b6a171$export$b60f3aad14353aa5, $d2247bac48b6a171$var$emailErrTxt, err);
};
async function $d2247bac48b6a171$var$sendData(info) {
    fetch("https://insaider.online/community/sign-up", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(info)
    }).then((response)=>{
        if (response !== "") response.json();
    }).then((data)=>console.log(data)).catch((e)=>console.log(e));
}
$d2247bac48b6a171$var$form.onsubmit = (e)=>{
    e.preventDefault();
    const username = $d2247bac48b6a171$export$5a2bf26922253ae6.value;
    const email = $d2247bac48b6a171$export$b60f3aad14353aa5.value;
    let err = false;
    if (username === "") {
        $d2247bac48b6a171$var$setError($d2247bac48b6a171$var$usernameLabel, $d2247bac48b6a171$export$5a2bf26922253ae6, $d2247bac48b6a171$var$usernameErrTxt, $d2247bac48b6a171$var$emptyFieldError);
        err = true;
    }
    switch(email){
        case "":
            $d2247bac48b6a171$var$setEmailError($d2247bac48b6a171$var$emptyFieldError);
            err = true;
            break;
        default:
            if (!$d2247bac48b6a171$var$validateEmail(email)) {
                $d2247bac48b6a171$var$setEmailError($d2247bac48b6a171$var$invalidEmailError);
                err = true;
            }
    }
    if (err) return;
    const userInfo = {
        "name": username,
        "email": email,
        "community_id": 1
    };
    $d2247bac48b6a171$var$sendData(userInfo);
    window.location.replace("/successful-registration" + window.location.hash);
    $d2247bac48b6a171$export$dc46a306c32dfa78();
};

});

function $8ad6d5bbb35fd69b$var$t() {
    return $8ad6d5bbb35fd69b$var$t = Object.assign ? Object.assign.bind() : function(t) {
        for(var s = 1; s < arguments.length; s++){
            var e = arguments[s];
            for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }
        return t;
    }, $8ad6d5bbb35fd69b$var$t.apply(this, arguments);
}
var $8ad6d5bbb35fd69b$var$s = {
    strings: [
        "These are the default values...",
        "You know what you should do?",
        "Use your own!",
        "Have a great day!"
    ],
    stringsElement: null,
    typeSpeed: 0,
    startDelay: 0,
    backSpeed: 0,
    smartBackspace: !0,
    shuffle: !1,
    backDelay: 700,
    fadeOut: !1,
    fadeOutClass: "typed-fade-out",
    fadeOutDelay: 500,
    loop: !1,
    loopCount: Infinity,
    showCursor: !0,
    cursorChar: "|",
    autoInsertCss: !0,
    attr: null,
    bindInputFocusEvents: !1,
    contentType: "html",
    onBegin: function(t) {},
    onComplete: function(t) {},
    preStringTyped: function(t, s) {},
    onStringTyped: function(t, s) {},
    onLastStringBackspaced: function(t) {},
    onTypingPaused: function(t, s) {},
    onTypingResumed: function(t, s) {},
    onReset: function(t) {},
    onStop: function(t, s) {},
    onStart: function(t, s) {},
    onDestroy: function(t) {}
}, $8ad6d5bbb35fd69b$var$e = new /*#__PURE__*/ (function() {
    function e() {}
    var n = e.prototype;
    return n.load = function(e, n, i) {
        if (e.el = "string" == typeof i ? document.querySelector(i) : i, e.options = $8ad6d5bbb35fd69b$var$t({}, $8ad6d5bbb35fd69b$var$s, n), e.isInput = "input" === e.el.tagName.toLowerCase(), e.attr = e.options.attr, e.bindInputFocusEvents = e.options.bindInputFocusEvents, e.showCursor = !e.isInput && e.options.showCursor, e.cursorChar = e.options.cursorChar, e.cursorBlinking = !0, e.elContent = e.attr ? e.el.getAttribute(e.attr) : e.el.textContent, e.contentType = e.options.contentType, e.typeSpeed = e.options.typeSpeed, e.startDelay = e.options.startDelay, e.backSpeed = e.options.backSpeed, e.smartBackspace = e.options.smartBackspace, e.backDelay = e.options.backDelay, e.fadeOut = e.options.fadeOut, e.fadeOutClass = e.options.fadeOutClass, e.fadeOutDelay = e.options.fadeOutDelay, e.isPaused = !1, e.strings = e.options.strings.map(function(t) {
            return t.trim();
        }), e.stringsElement = "string" == typeof e.options.stringsElement ? document.querySelector(e.options.stringsElement) : e.options.stringsElement, e.stringsElement) {
            e.strings = [], e.stringsElement.style.cssText = "clip: rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px;";
            var r = Array.prototype.slice.apply(e.stringsElement.children), o = r.length;
            if (o) for(var a = 0; a < o; a += 1)e.strings.push(r[a].innerHTML.trim());
        }
        for(var u in e.strPos = 0, e.currentElContent = this.getCurrentElContent(e), e.currentElContent && e.currentElContent.length > 0 && (e.strPos = e.currentElContent.length - 1, e.strings.unshift(e.currentElContent)), e.sequence = [], e.strings)e.sequence[u] = u;
        e.arrayPos = 0, e.stopNum = 0, e.loop = e.options.loop, e.loopCount = e.options.loopCount, e.curLoop = 0, e.shuffle = e.options.shuffle, e.pause = {
            status: !1,
            typewrite: !0,
            curString: "",
            curStrPos: 0
        }, e.typingComplete = !1, e.autoInsertCss = e.options.autoInsertCss, e.autoInsertCss && (this.appendCursorAnimationCss(e), this.appendFadeOutAnimationCss(e));
    }, n.getCurrentElContent = function(t) {
        return t.attr ? t.el.getAttribute(t.attr) : t.isInput ? t.el.value : "html" === t.contentType ? t.el.innerHTML : t.el.textContent;
    }, n.appendCursorAnimationCss = function(t) {
        var s = "data-typed-js-cursor-css";
        if (t.showCursor && !document.querySelector("[" + s + "]")) {
            var e = document.createElement("style");
            e.setAttribute(s, "true"), e.innerHTML = "\n        .typed-cursor{\n          opacity: 1;\n        }\n        .typed-cursor.typed-cursor--blink{\n          animation: typedjsBlink 0.7s infinite;\n          -webkit-animation: typedjsBlink 0.7s infinite;\n                  animation: typedjsBlink 0.7s infinite;\n        }\n        @keyframes typedjsBlink{\n          50% { opacity: 0.0; }\n        }\n        @-webkit-keyframes typedjsBlink{\n          0% { opacity: 1; }\n          50% { opacity: 0.0; }\n          100% { opacity: 1; }\n        }\n      ", document.body.appendChild(e);
        }
    }, n.appendFadeOutAnimationCss = function(t) {
        var s = "data-typed-fadeout-js-css";
        if (t.fadeOut && !document.querySelector("[" + s + "]")) {
            var e = document.createElement("style");
            e.setAttribute(s, "true"), e.innerHTML = "\n        .typed-fade-out{\n          opacity: 0;\n          transition: opacity .25s;\n        }\n        .typed-cursor.typed-cursor--blink.typed-fade-out{\n          -webkit-animation: 0;\n          animation: 0;\n        }\n      ", document.body.appendChild(e);
        }
    }, e;
}()), $8ad6d5bbb35fd69b$var$n = new /*#__PURE__*/ (function() {
    function t() {}
    var s = t.prototype;
    return s.typeHtmlChars = function(t, s, e) {
        if ("html" !== e.contentType) return s;
        var n = t.substring(s).charAt(0);
        if ("<" === n || "&" === n) {
            var i;
            for(i = "<" === n ? ">" : ";"; t.substring(s + 1).charAt(0) !== i && !(1 + ++s > t.length););
            s++;
        }
        return s;
    }, s.backSpaceHtmlChars = function(t, s, e) {
        if ("html" !== e.contentType) return s;
        var n = t.substring(s).charAt(0);
        if (">" === n || ";" === n) {
            var i;
            for(i = ">" === n ? "<" : "&"; t.substring(s - 1).charAt(0) !== i && !(--s < 0););
            s--;
        }
        return s;
    }, t;
}()), $8ad6d5bbb35fd69b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function t(t, s) {
        $8ad6d5bbb35fd69b$var$e.load(this, s, t), this.begin();
    }
    var s = t.prototype;
    return s.toggle = function() {
        this.pause.status ? this.start() : this.stop();
    }, s.stop = function() {
        this.typingComplete || this.pause.status || (this.toggleBlinking(!0), this.pause.status = !0, this.options.onStop(this.arrayPos, this));
    }, s.start = function() {
        this.typingComplete || this.pause.status && (this.pause.status = !1, this.pause.typewrite ? this.typewrite(this.pause.curString, this.pause.curStrPos) : this.backspace(this.pause.curString, this.pause.curStrPos), this.options.onStart(this.arrayPos, this));
    }, s.destroy = function() {
        this.reset(!1), this.options.onDestroy(this);
    }, s.reset = function(t) {
        void 0 === t && (t = !0), clearInterval(this.timeout), this.replaceText(""), this.cursor && this.cursor.parentNode && (this.cursor.parentNode.removeChild(this.cursor), this.cursor = null), this.strPos = 0, this.arrayPos = 0, this.curLoop = 0, t && (this.insertCursor(), this.options.onReset(this), this.begin());
    }, s.begin = function() {
        var t = this;
        this.options.onBegin(this), this.typingComplete = !1, this.shuffleStringsIfNeeded(this), this.insertCursor(), this.bindInputFocusEvents && this.bindFocusEvents(), this.timeout = setTimeout(function() {
            0 === t.strPos ? t.typewrite(t.strings[t.sequence[t.arrayPos]], t.strPos) : t.backspace(t.strings[t.sequence[t.arrayPos]], t.strPos);
        }, this.startDelay);
    }, s.typewrite = function(t, s) {
        var e = this;
        this.fadeOut && this.el.classList.contains(this.fadeOutClass) && (this.el.classList.remove(this.fadeOutClass), this.cursor && this.cursor.classList.remove(this.fadeOutClass));
        var i = this.humanizer(this.typeSpeed), r = 1;
        !0 !== this.pause.status ? this.timeout = setTimeout(function() {
            s = $8ad6d5bbb35fd69b$var$n.typeHtmlChars(t, s, e);
            var i = 0, o = t.substring(s);
            if ("^" === o.charAt(0) && /^\^\d+/.test(o)) {
                var a = 1;
                a += (o = /\d+/.exec(o)[0]).length, i = parseInt(o), e.temporaryPause = !0, e.options.onTypingPaused(e.arrayPos, e), t = t.substring(0, s) + t.substring(s + a), e.toggleBlinking(!0);
            }
            if ("`" === o.charAt(0)) {
                for(; "`" !== t.substring(s + r).charAt(0) && (r++, !(s + r > t.length)););
                var u = t.substring(0, s), p = t.substring(u.length + 1, s + r), c = t.substring(s + r + 1);
                t = u + p + c, r--;
            }
            e.timeout = setTimeout(function() {
                e.toggleBlinking(!1), s >= t.length ? e.doneTyping(t, s) : e.keepTyping(t, s, r), e.temporaryPause && (e.temporaryPause = !1, e.options.onTypingResumed(e.arrayPos, e));
            }, i);
        }, i) : this.setPauseStatus(t, s, !0);
    }, s.keepTyping = function(t, s, e) {
        0 === s && (this.toggleBlinking(!1), this.options.preStringTyped(this.arrayPos, this));
        var n = t.substring(0, s += e);
        this.replaceText(n), this.typewrite(t, s);
    }, s.doneTyping = function(t, s) {
        var e = this;
        this.options.onStringTyped(this.arrayPos, this), this.toggleBlinking(!0), this.arrayPos === this.strings.length - 1 && (this.complete(), !1 === this.loop || this.curLoop === this.loopCount) || (this.timeout = setTimeout(function() {
            e.backspace(t, s);
        }, this.backDelay));
    }, s.backspace = function(t, s) {
        var e = this;
        if (!0 !== this.pause.status) {
            if (this.fadeOut) return this.initFadeOut();
            this.toggleBlinking(!1);
            var i = this.humanizer(this.backSpeed);
            this.timeout = setTimeout(function() {
                s = $8ad6d5bbb35fd69b$var$n.backSpaceHtmlChars(t, s, e);
                var i = t.substring(0, s);
                if (e.replaceText(i), e.smartBackspace) {
                    var r = e.strings[e.arrayPos + 1];
                    e.stopNum = r && i === r.substring(0, s) ? s : 0;
                }
                s > e.stopNum ? (s--, e.backspace(t, s)) : s <= e.stopNum && (e.arrayPos++, e.arrayPos === e.strings.length ? (e.arrayPos = 0, e.options.onLastStringBackspaced(), e.shuffleStringsIfNeeded(), e.begin()) : e.typewrite(e.strings[e.sequence[e.arrayPos]], s));
            }, i);
        } else this.setPauseStatus(t, s, !1);
    }, s.complete = function() {
        this.options.onComplete(this), this.loop ? this.curLoop++ : this.typingComplete = !0;
    }, s.setPauseStatus = function(t, s, e) {
        this.pause.typewrite = e, this.pause.curString = t, this.pause.curStrPos = s;
    }, s.toggleBlinking = function(t) {
        this.cursor && (this.pause.status || this.cursorBlinking !== t && (this.cursorBlinking = t, t ? this.cursor.classList.add("typed-cursor--blink") : this.cursor.classList.remove("typed-cursor--blink")));
    }, s.humanizer = function(t) {
        return Math.round(Math.random() * t / 2) + t;
    }, s.shuffleStringsIfNeeded = function() {
        this.shuffle && (this.sequence = this.sequence.sort(function() {
            return Math.random() - .5;
        }));
    }, s.initFadeOut = function() {
        var t = this;
        return this.el.className += " " + this.fadeOutClass, this.cursor && (this.cursor.className += " " + this.fadeOutClass), setTimeout(function() {
            t.arrayPos++, t.replaceText(""), t.strings.length > t.arrayPos ? t.typewrite(t.strings[t.sequence[t.arrayPos]], 0) : (t.typewrite(t.strings[0], 0), t.arrayPos = 0);
        }, this.fadeOutDelay);
    }, s.replaceText = function(t) {
        this.attr ? this.el.setAttribute(this.attr, t) : this.isInput ? this.el.value = t : "html" === this.contentType ? this.el.innerHTML = t : this.el.textContent = t;
    }, s.bindFocusEvents = function() {
        var t = this;
        this.isInput && (this.el.addEventListener("focus", function(s) {
            t.stop();
        }), this.el.addEventListener("blur", function(s) {
            t.el.value && 0 !== t.el.value.length || t.start();
        }));
    }, s.insertCursor = function() {
        this.showCursor && (this.cursor || (this.cursor = document.createElement("span"), this.cursor.className = "typed-cursor", this.cursor.setAttribute("aria-hidden", !0), this.cursor.innerHTML = this.cursorChar, this.el.parentNode && this.el.parentNode.insertBefore(this.cursor, this.el.nextSibling)));
    }, t;
}();



var $8WpX6 = parcelRequire("8WpX6");
const $39ab1deee77acc45$var$colors = [
    "pink",
    "sky",
    "blue"
];
const $39ab1deee77acc45$var$accordionRoot = document.getElementById("accordion-root");
(0, $8WpX6.accordionData).forEach(({ text: text, title: title }, i)=>{
    $39ab1deee77acc45$var$accordionRoot.insertAdjacentHTML("beforeend", `
        <div class="accordion ${$39ab1deee77acc45$var$colors[i % $39ab1deee77acc45$var$colors.length]}">
           <div class="accordion__titlecontainer">
              <p class="acc-title">${title}</p>
              <div class="accordion__icon"></div>
           </div>
           <div class="accordion__body">
              <p class="text">${text}</p>
           </div>
        </div>     
    `);
});
const $39ab1deee77acc45$var$elems = document.querySelectorAll(".accordion");
$39ab1deee77acc45$var$elems.forEach((el)=>{
    el.addEventListener("click", ()=>{
        $39ab1deee77acc45$var$elems.forEach((elem)=>el != elem ? elem.classList.remove("active") : null);
        el.classList.toggle("active");
    });
});



var $i2AbA = parcelRequire("i2AbA");

var $8WpX6 = parcelRequire("8WpX6");

var $8fJPx = parcelRequire("8fJPx");
// Short Benefits Generation
const $8f6a480bb40b134f$var$benefitsShortContainer = document.getElementById("benefits-short-container");
(0, $8WpX6.benefitsShortData).forEach((card, i)=>{
    $8f6a480bb40b134f$var$benefitsShortContainer.insertAdjacentHTML("beforeend", `
      <div>
        <h3 id="short-benefit-card-heading-${i}">${card.h3}</h3>
        ${card.svg}
      </div>
    `);
});
const $8f6a480bb40b134f$var$menuBtn = document.querySelector("#menu-toggle");
const $8f6a480bb40b134f$var$navMenu = document.querySelector("nav");
const $8f6a480bb40b134f$var$header = document.querySelector("header");
// NavBar
$8f6a480bb40b134f$var$menuBtn.addEventListener("click", ()=>{
    if ($8f6a480bb40b134f$var$navMenu.style.visibility !== "visible") {
        $8f6a480bb40b134f$var$navMenu.style.visibility = "visible";
        $8f6a480bb40b134f$var$header.style.position = "fixed";
        $8f6a480bb40b134f$var$header.style.top = "0";
        $8f6a480bb40b134f$var$header.style.zIndex = "100";
        $8f6a480bb40b134f$var$menuBtn.classList.add("nav-open");
    } else {
        $8f6a480bb40b134f$var$navMenu.style.visibility = "hidden";
        $8f6a480bb40b134f$var$header.style.position = "static";
        $8f6a480bb40b134f$var$menuBtn.classList.remove("nav-open");
    }
});
// Register Form
const $8f6a480bb40b134f$var$formOverlay = document.querySelector(".form-overlay");
const $8f6a480bb40b134f$var$slider = document.getElementById("slider");
const $8f6a480bb40b134f$var$switchCheckbox = document.getElementById("switch-checkbox");
const $8f6a480bb40b134f$var$closeFormBtn = document.getElementById("form-close-btn");
const $8f6a480bb40b134f$var$navFormLink = document.getElementById("nav-form-link");
let $8f6a480bb40b134f$var$curMode = "Email";
const $8f6a480bb40b134f$var$getOppositeMode = (mode)=>mode === "Email" ? "Telegram" : "Email";
function $8f6a480bb40b134f$var$setFormStructure(option) {
    if (option === "Email") $8f6a480bb40b134f$var$formOverlay.classList.remove("form-tg-mode");
    else $8f6a480bb40b134f$var$formOverlay.classList.add("form-tg-mode");
    $8f6a480bb40b134f$var$slider.style.justifyContent = option === "Email" ? "end" : "start";
    $8f6a480bb40b134f$var$slider.textContent = $8f6a480bb40b134f$var$getOppositeMode(option);
    $8f6a480bb40b134f$var$slider.classList.remove(`${$8f6a480bb40b134f$var$getOppositeMode(option).toLowerCase()}-icon`);
    $8f6a480bb40b134f$var$slider.classList.add(option.toLowerCase() + "-icon");
}
$8f6a480bb40b134f$var$navFormLink.addEventListener("click", ()=>{
    $8f6a480bb40b134f$var$formOverlay.classList.add("form-active");
    $8f6a480bb40b134f$var$navMenu.style.visibility = "hidden";
    $8f6a480bb40b134f$var$header.style.position = "static";
    $8f6a480bb40b134f$var$menuBtn.classList.remove("nav-open");
});
$8f6a480bb40b134f$var$slider.addEventListener("click", (e)=>{
    $8f6a480bb40b134f$var$curMode = $8f6a480bb40b134f$var$getOppositeMode($8f6a480bb40b134f$var$curMode);
    $8f6a480bb40b134f$var$setFormStructure($8f6a480bb40b134f$var$curMode);
});
$8f6a480bb40b134f$var$closeFormBtn.addEventListener("click", (e)=>{
    e.preventDefault();
    $8f6a480bb40b134f$var$curMode = "Email";
    $8f6a480bb40b134f$var$setFormStructure($8f6a480bb40b134f$var$curMode);
    $8f6a480bb40b134f$var$switchCheckbox.checked = false;
    (0, $i2AbA.cleanForm)();
    $8f6a480bb40b134f$var$formOverlay.classList.remove("form-active");
});
const $8f6a480bb40b134f$var$benefitsLongContainer = document.getElementById("benefits-long-container");
let $8f6a480bb40b134f$var$pausedTypedStrings = (0, $8WpX6.typedStrings).en.map((str)=>"^1000 " + str);
(0, $8fJPx.recognizeUserLang)($8f6a480bb40b134f$var$setLanguage);
function $8f6a480bb40b134f$var$setLanguage(lang) {
    // Main Page
    $8f6a480bb40b134f$var$pausedTypedStrings = (0, $8WpX6.typedStrings)[lang].map((str)=>"^1000 " + str);
    for(let key in 0, $8WpX6.langData)document.getElementById(`${key}`).textContent = (0, $8WpX6.langData)[key][lang];
    // Benefits Cards Generation
    $8f6a480bb40b134f$var$benefitsLongContainer.replaceChildren();
    (0, $8WpX6.benefitsCards)[lang].forEach((el, i)=>{
        i % 2 === 0 ? $8f6a480bb40b134f$var$benefitsLongContainer.insertAdjacentHTML("beforeend", `
        <div class="benefit-card">
              <div class="benefit-card__text-box">
                <h3>${el.h1}</h3>
                <span>${el.text1}</span>
                <h3>${el.h2}</h3>
                <span>${el.text2}</span>
                <button class="register-btn">${el.btnText}</button>
              </div>
              <img src="${el.img.src}" alt="${el.img.alt}">
            </div>`) : $8f6a480bb40b134f$var$benefitsLongContainer.insertAdjacentHTML("beforeend", `
        <div class="benefit-card">
              <img src="${el.img.src}" alt="${el.img.alt}">
              <div class="benefit-card__text-box">
                <h3>${el.h1}</h3>
                <span>${el.text1}</span>
                <h3>${el.h2}</h3>
                <span>${el.text2}</span>
                <button class="register-btn">${el.btnText}</button>
              </div>
            </div>`);
    });
}
// Register Buttons Logic
const $8f6a480bb40b134f$var$registerBtns = document.querySelectorAll(".register-btn");
$8f6a480bb40b134f$var$registerBtns.forEach((btn)=>{
    btn.addEventListener("click", ()=>{
        $8f6a480bb40b134f$var$formOverlay.classList.add("form-active");
    });
});
// Typed Text
const $8f6a480bb40b134f$var$typedTextSpan = document.getElementById("typed-text");
const $8f6a480bb40b134f$var$typedTextLastIndex = $8f6a480bb40b134f$var$pausedTypedStrings.length - 1;
const $8f6a480bb40b134f$var$mainRegisterBtn = document.getElementById("main-register-btn");
let $8f6a480bb40b134f$var$firstTypedIncome = true;
function $8f6a480bb40b134f$var$changeMainGradients(strI, lastStrI) {
    if (strI === 0 && !$8f6a480bb40b134f$var$firstTypedIncome) {
        $8f6a480bb40b134f$var$typedTextSpan.classList.remove(`typed-style-${lastStrI}`);
        $8f6a480bb40b134f$var$mainRegisterBtn.classList.remove(`main-btn-style-${lastStrI}`);
    } else {
        $8f6a480bb40b134f$var$typedTextSpan.classList.remove(`typed-style-${strI - 1}`);
        $8f6a480bb40b134f$var$mainRegisterBtn.classList.remove(`main-btn-style-${strI - 1}`);
    }
    $8f6a480bb40b134f$var$typedTextSpan.classList.add(`typed-style-${strI}`);
    $8f6a480bb40b134f$var$mainRegisterBtn.classList.add(`main-btn-style-${strI}`);
}
const $8f6a480bb40b134f$var$typeOptions = {
    strings: $8f6a480bb40b134f$var$pausedTypedStrings,
    typeSpeed: 90,
    backSpeed: 70,
    backDelay: 3000,
    loop: true,
    loopCount: Infinity,
    preStringTyped: (arrPos)=>{
        $8f6a480bb40b134f$var$changeMainGradients(arrPos, $8f6a480bb40b134f$var$typedTextLastIndex);
    },
    onComplete: ()=>{
        $8f6a480bb40b134f$var$firstTypedIncome = false;
    }
};
const $8f6a480bb40b134f$var$typed = new (0, $8ad6d5bbb35fd69b$export$2e2bcd8739ae039)($8f6a480bb40b134f$var$typedTextSpan, $8f6a480bb40b134f$var$typeOptions);


//# sourceMappingURL=index.e1f6c47c.js.map
